/**
 * get if time is before the beginning of current hour
 * @param arg time to check
 */
export function getIsPastHours(arg: number): boolean {
  const currentHour = new Date();
  // beginning of current hour
  currentHour.setMinutes(0);
  currentHour.setSeconds(0);
  currentHour.setMilliseconds(0);

  return arg < +currentHour;
}
